import * as Api from "../api/withdrawal.js";

export const agentRequestWithdrawal = async (token, cryptoCurrency, network, address, amount, currency, maxSet, callback) => {
	try {
		const { data } = await Api.agentRequestWithdrawal(token, cryptoCurrency, network, address, amount, currency, maxSet);
		callback(data);
	} catch (error) {
		console.log("agentRequestWithdrawal error", error);
	}
};

export const getWithdrawals = async (token, id, type, callback) => {
	try {
		const { data } = await Api.getWithdrawals(token, id, type);
		callback(data);
	} catch (error) {
		console.log("getWithdrawals error", error);
	}
};

export const getWithdrawalsPending = async (token, id, callback) => {
	try {
		const { data } = await Api.getWithdrawalsPending(token, id);
		callback(data);
	} catch (error) {
		console.log("getWithdrawalsPending error", error);
	}
};

export const processWithdrawalResponse = async (token, id, accept, callback) => {
	try {
		const { data } = await Api.processWithdrawalResponse(token, id, accept);
		callback(data);
	} catch (error) {
		console.log("processWithdrawalResponse error", error);
	}
};
